import { render, staticRenderFns } from "./SettlementsTitle.vue?vue&type=template&id=7990087f&scoped=true"
import script from "./SettlementsTitle.vue?vue&type=script&lang=js"
export * from "./SettlementsTitle.vue?vue&type=script&lang=js"
import style0 from "./SettlementsTitle.vue?vue&type=style&index=0&id=7990087f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7990087f",
  null
  
)

export default component.exports